/**
 * Generated runtime TestId mirror for frontend/src/pages/LlmPrompts.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const LlmPromptsTestIds = {
  colDescription: "col-description",
  colDisplayName: "col-display-name",
  colKey: "col-key",
  colLastUpdated: "col-last-updated",
  llmPromptsList: "llm-prompts-list",
  llmPromptsTable: "llm-prompts-table",
  llmPromptRow: (template_key: string) => `llm-prompt-row-${template_key}`,
  llmPromptRowPrefix: () => "llm-prompt-row-" as TestIdPrefix
} as const;
